import { createAction, props } from '@ngrx/store';
import { EstruturaRetornoDadosOutputDto } from 'src/app/domain/DTOs/output/estrutura-retorno-dados.output.dto';
import { EdicaoOutputDto } from 'src/app/domain/DTOs/output/jornal/edicao-output.dto';

const actionName = "[ ObterEdicaoPorId ] Obter Edicao Por Id";

export const obterEdicaoPorId = createAction(
  actionName,
  props<{ inputDto: number, pagina?: number}>()
);

export const obterEdicaoPorIdSuccess = createAction(
  `${actionName} - Sucesso`,
  props<{ response: EstruturaRetornoDadosOutputDto<EdicaoOutputDto> }>()
);

export const obterEdicaoPorIdFailure = createAction(
  `${actionName} - Falha`,
  props<{ response: EstruturaRetornoDadosOutputDto<EdicaoOutputDto> }>()
);

export const obterEdicaoPorIdFinish = createAction(
  `${actionName} - Concluir`
);
